import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../../../assets/css/Country/CountryList.css';
const API_BASE_URL = process.env.REACT_APP_API_URL;
// Set default authorization header for all requests
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;

// Get permissions from localStorage
const userPermissions = JSON.parse(localStorage.getItem('permissions') || '[]');
const canCreate = userPermissions.includes("create_Country");
const canEdit = userPermissions.includes("update_Country");
const canDelete = userPermissions.includes("delete_Country");

const CountryList = () => {
  const [countries, setCountries] = useState([]);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  const fetchCountries = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/countries`);
      setCountries(res.data);
    } catch (err) {
      console.error("Error fetching countries:", err);
      alert("Failed to fetch countries");
    }
  };

  const toggleStatus = async (id) => {
    if (!canEdit) {
      alert("You do not have permission to update status.");
      return;
    }
    try {
      await axios.put(`${API_BASE_URL}/api/countries/${id}/status`);
      fetchCountries();
    } catch (err) {
      console.error("Error toggling status:", err);
      alert("Failed to toggle status.");
    }
  };

  const deleteCountry = async (id) => {
    if (!canDelete) {
      alert("You do not have permission to delete.");
      return;
    }
    if (window.confirm('Are you sure you want to delete this country?')) {
      try {
        await axios.delete(`${API_BASE_URL}/api/countries/${id}`);
        fetchCountries();
      } catch (err) {
        console.error("Error deleting country:", err);
        alert("Failed to delete country.");
      }
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  const filtered = countries.filter((c) =>
    c.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleBlockedClick = (message) => {
    alert(message);
  };

  return (
    <div className="container mt-4">
      <div className="country-header d-flex justify-content-between align-items-center mb-4">
        <h4 className="fw-bold mb-0">Country List</h4>
        <button
          className={`btn shadow-sm ${!canCreate ? 'btn-disabled' : ''}`}
          onClick={() =>
            canCreate
              ? navigate('/country/add')
              : handleBlockedClick("You do not have permission to add.")
          }
          title={canCreate ? "Add Country" : "No permission"}
          style={{ cursor: canCreate ? 'pointer' : 'not-allowed' }}
        >
          + Add Country
        </button>
      </div>

      <div className="search-bar mb-4">
        <input
          type="text"
          className="form-control shadow-sm"
          placeholder="🔍 Search by country name"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="table-responsive country-table-wrapper">
        <table className="table table-bordered table-hover text-center shadow-sm">
          <thead className="table-dark text-white">
            <tr>
              <th>No.</th>
              <th>Name</th>
              <th>Code</th>
              <th>Remarks</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((c, i) => (
              <tr key={c._id}>
                <td>{i + 1}</td>
                <td>{c.name}</td>
                <td>{c.code}</td>
                <td>{c.remarks || '-'}</td>
                <td>
                  <div className="form-check form-switch d-flex justify-content-center">
                    <input
                      className={`form-check-input ${c.status ? 'switch-on' : 'switch-off'}`}
                      type="checkbox"
                      checked={c.status}
                      onChange={() => toggleStatus(c._id)}
                      disabled={!canEdit}
                      title={!canEdit ? "No permission to change status" : "Toggle Status"}
                      style={{ cursor: canEdit ? 'pointer' : 'not-allowed' }}
                    />
                  </div>
                </td>
                <td>
                  <button
                    onClick={() =>
                      canEdit
                        ? navigate(`/country/${c._id}`)
                        : handleBlockedClick("You do not have permission to edit.")
                    }
                    className={`btn btn-sm me-2 ${canEdit ? 'btn-outline-primary' : 'btn-disabled'}`}
                    style={{ cursor: canEdit ? 'pointer' : 'not-allowed' }}
                    title={canEdit ? "Edit Country" : "No permission to edit"}
                  >
                    ✏️
                  </button>
                  <button
                    onClick={() =>
                      canDelete
                        ? deleteCountry(c._id)
                        : handleBlockedClick("You do not have permission to delete.")
                    }
                    className={`btn btn-sm ${canDelete ? 'btn-outline-danger' : 'btn-disabled'}`}
                    style={{ cursor: canDelete ? 'pointer' : 'not-allowed' }}
                    title={canDelete ? "Delete Country" : "No permission to delete"}
                  >
                    🗑️
                  </button>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr>
                <td colSpan="6" className="text-muted text-center">
                  No countries found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CountryList;
